<template>
  <div class="headerCss">
    <div
      class="logo_left"
      @click="jumpConfig(indexPage.menu_router,indexPage.sub_menu,indexPage.id,true)"
      v-if="logo_flag"
    >
      <!-- <img src="../statics/logo-1.png" alt="" /> -->
      <img
        :src="logo"
        alt=""
      />
    </div>
    <div class="headerContBox">
      <el-menu
        ellipsis
        :default-active="activeIndex2"
        class="el-menu-demo"
        mode="horizontal"
        text-color="#2c3e50"
        active-text-color="#165dff"
      >
        <el-menu-item
          v-if="!logo_flag"
          @click="jumpConfig(indexPage.menu_router,indexPage.sub_menu,indexPage.id,true)"
        >
          <span class="menuFontSize">首页</span>
        </el-menu-item>
        <el-menu-item
          v-for="items in otherMenu"
          :key="items.id"
          :index="items.menu_router"
          @click="jumpConfig(items.menu_router, items.sub_menu, items.id)"
        >
          <div :class="{click_bg:click_id == items.id ?true:false}"><i
            v-if="items.menu_icon"
            class="fa"
            :style="{ color: '#' + items.icon_color }"
            :class="items.menu_icon.slice(1, -1)"
          ></i><span class="menuFontSize">{{ items.menu_name }}</span></div>
        </el-menu-item>
      </el-menu>
    </div>
    <div class="header_rightBox">
      <div v-if="role_id == 1">
        <el-button v-if="task_status == 'start'" type="danger" plain @click="change_task('stop')">
          <el-icon style="font-size: 16px">
            <SwitchButton/>
          </el-icon>
          &nbsp;一键暂停所有任务
        </el-button>
        <el-button v-if="task_status == 'stop'" type="success" plain @click="change_task('start')">
          <el-icon style="font-size: 16px">
            <RefreshLeft/>
          </el-icon>
          &nbsp;一键恢复所有任务
        </el-button>
      </div>
      <el-dropdown
        trigger="hover"
        teleported
        popper-class="userDropdown"
        placement="bottom-end"
      >
        <span class="el-dropdown-link userInfo">
          <div class="header_photo">
            <img
              src="../statics/pz_touxiang.png"
              alt=""
            />
          </div>
          <div class="header_right_two">
            <span>【{{ role_name }}】</span>{{ username }}
          </div>
          <el-icon class="el-icon--right">
            <arrow-down/>
          </el-icon>
        </span>
        <template #dropdown>
          <el-dropdown-menu class="dropdownMenu">
            <el-dropdown-item
              class="dropdownMenuItem"
              @click="openHistory"
            >
              <img
                src="@/assets/login/history.png"
                alt=""
              >历史公告
            </el-dropdown-item>
            <el-dropdown-item
              class="dropdownMenuItem"
              @click="handleSeats"
            ><img
              src="@/assets/login/seats.png"
              alt=""
            >坐席状态
            </el-dropdown-item>
            <el-dropdown-item
              class="dropdownMenuItem"
              @click="handleEditPaw"
            ><img
              src="@/assets/login/edit.png"
              alt=""
            >修改密码
            </el-dropdown-item>
            <el-dropdown-item
              class="dropdownMenuItem"
              @click="loginOut"
            >
              <img
                src="@/assets/login/out.png"
                alt=""
              >退出登录
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>

      <!-- <div class="header_right_two">余额：{{ balance }}</div> -->
      <!-- <div class="header_right_two">
        <span>【{{ role_name }}】</span>{{ username }}
      </div>

      <div
        class="header_right"
        @click="loginOut"
      >退出登录</div> -->
    </div>
    <!-- <div style="clear: both;"></div> -->
  </div>
  <EditPaw ref="editPaw"></EditPaw>
  <Seats ref="seats"></Seats>
  <History ref="history"></History>
</template>
<style lang="scss" scoped>
:deep(.el-menu-sqm .el-menu-item[data-v-257c8456]) {
  font-size: 15px;
}

:deep(.el-menu-item::after) {
  content: '';
  font-size: 15px;
  background-color: #ccc;
  width: 1px;
  position: absolute;
  right: 0;
  height: 15px;
}

:deep(.el-menu-item:nth-last-child(1)::after) {
  content: '';
  font-size: 15px;
  background-color: transparent;
  width: 1px;
  position: absolute;
  right: 0;
  height: 15px;
}

.fa {
  margin-right: 10px;
  font-size: 20px;
  color: #409eff;
}

.fa:nth-child(1) {
  font-size: 24px;
}

.headerCss {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;

  .logo_left {
    height: 80px;
    display: flex;
    align-items: center;

    cursor: pointer;
    margin-right: 10px;

    img {
      width: 150px;
      height: 50px;
      object-fit: cover;
    }
  }

  .headerContBox {
    height: 100%;
    width: calc(100% - 220px - 150px);

    border-bottom: 0;
  }

  .header_rightBox {
    width: auto;
    height: 50px;
    display: flex;
    align-items: center;
    margin-left: auto;
    gap: 16px;
    margin-right: 16px;
    font-size: 16px;
    cursor: pointer;

    .header_right {
      font-size: 16px;
      height: 65px;
      width: 15%;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .header_right:hover {
      background-color: #ecf5ff;
      transition: all 0.5s;
      cursor: pointer;
    }

    .header_right_two {
      display: flex;
      align-items: center;
      font-size: 16px;
      color: #333;
      white-space: nowrap;
    }

    .header_photo {
      padding: 20px 0;
      width: 40px;
      height: 40px;
    }

    .header_photo img {
      border-radius: 20px;
    }
  }
}

.el-menu {
  // background: linear-gradient(to right, #e6f3ff 0%, #ebfeff 100%);
  height: 100%;
  border-bottom: none;
}

.click_bg {
  display: flex;
  align-items: center;
  height: 100%;
  color: #165dff;
  // background-color: #fff;
  border-bottom: 2px solid #165dff;
}

:deep .el-menu-item.is-active {
  border: 0;
}

.el-menu-item:hover {
  color: #165dff !important;
}

.menuFontSize {
  font-size: 20px;
}

.userInfo {
  display: flex;
  align-items: center;
}
</style>
<style lang="scss">
.dropdownMenu {
  .dropdownMenuItem {
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 16px;
      height: 16px;
      margin-right: 5px;
    }
  }
}

.userDropdown {
  width: 160px;
  inset: 66px 36px auto auto !important;
  text-align: center;

  .el-dropdown-menu__item {
    justify-content: center;
    font-size: 16px;
  }

  .el-popper__arrow {
    display: none;
  }

  .el-popper__arrow::before {
    display: none;
  }
}

*:focus-visible {
  outline: 0 !important;
}
</style>
<script setup name="HeaderNav">
// import svgIcon from './svgIcon.vue';
import api from "@/api/api"
import {useStorage} from '@vueuse/core'
import {computed, onMounted, ref, onBeforeUnmount} from 'vue'
import {useRouter, useRoute} from 'vue-router'
import {storeToRefs} from 'pinia' //引入pinia
import {useIndexSore} from '@/store/modules/app'
import {ElMessage, ElMessageBox} from 'element-plus'

import EditPaw from './EditPaw.vue'
import Seats from './Seats.vue'
import History from '@/views/system/noticeHistory.vue'

const editPaw = ref(null)
const seats = ref(null)

const router = useRouter()
const activeIndex2 = ref('1')
const store = useIndexSore()
const {menuState, menuId, subMenuState, subMenuId, staff_id, is_show_crm} =
  storeToRefs(store)
const menu = computed(() => menuState.value)
const indexPage = computed(() => {
  return menu.value[0]
})
const otherMenu = computed(() => {
  return menu.value.slice(1)
})

// 任务状态
const task_status = ref('')
const role_id = ref(useStorage("role_id"))
const username = ref(useStorage('username'))
const balance = ref(useStorage('balance'))
const role_name = ref(useStorage('role_name'))
const logo = ref('')
const logo_flag = ref(false)
const click_id = computed(() => menuId.value)
const siteInfo = ref(useStorage('site'))
const zy_host = useStorage('audioUrl')
const history = ref()
onMounted(() => {
  if (role_id.value == 1) {
    let task = localStorage.getItem('task_status') || '';
    if (task) {
      task_status.value = task;
    }
  }

  if (siteInfo.value) {
    let site = JSON.parse(siteInfo.value)
    if (site.company_logo) {
      logo.value = zy_host.value + '' + site.company_logo
      logo_flag.value = true
    }
  }
  if (is_show_crm.value === 'false') {
    is_show_crm.value = false
  }
  if (is_show_crm.value) {
    jumpConfig(
      menuState.value[0].menu_router,
      menuState.value[0].sub_menu,
      menuState.value[0].id
    )
  }
})
// const jumpIndex = function () {
//   router.push("/index");
// };
const loginOut = function () {
  let isp_key = localStorage.getItem('isp_key')
  // localStorage.clear()
  // 清除本地缓存数据
  let store_arr = [
    "token",
    "login_time",
    "userrobotEnableCnt",
    "audioUrl",
    "userEndTime",
    "role_name",
    "huashuInfo",
    "isp_key",
    "userrobotCnt",
    "balance",
    "userId",
    "menuState",
    "site",
    "role_id",
    "username",
    "task_status"
  ]
  store_arr.forEach(key => {
    localStorage.removeItem(key)
  })
  store.logout()
  router.push('/home' + isp_key)
}
/**
 * @param isIndex 是否为首页。默认为false
 */
const jumpConfig = function (url, sub_menu, id, isIndex = false) {
  //sub_menu 二级菜单
  // useStorage("subMenuState").value = subMenuState.value = sub_menu
  if (isIndex) {
    const eleList = document.querySelector('.headerContBox .el-menu')
    console.log(eleList.children)
    for (let item of eleList.children) {
      item.classList.remove('is-active')
    }
  }
  menuId.value = id
  localStorage.setItem('menuId', menuId.value)
  subMenuState.value = sub_menu
  // useStorage("subMenuId").value = subMenuId.value
  // useStorage("menuId").value = menuId.value

  // for (let i = 0; i < sub_menu.length; i++) {
  //     if (sub_menu[i].menu_router == url) {
  if (sub_menu) {
    subMenuId.value = sub_menu[0].id
    localStorage.setItem('subMenuState', JSON.stringify(subMenuState.value))
    localStorage.setItem('subMenuId', subMenuId.value)

    if (sub_menu[0].menu_router == 'dissingClues') {
      store.handleGetDsjToken().then(() => {
        router.push(sub_menu[0].menu_router)
      })
    } else {
      router.push(sub_menu[0].menu_router)
    }
  } else {
    router.push(url)
  }

  //     }
  // }

  /**
   * 修改密码
   */
}

function handleEditPaw() {
  console.log('修改密码')
  console.log(editPaw)

  editPaw.value.handleOpen()
}

function handleSeats() {
  console.log('查看坐席状态')
  seats.value.handleOpen()
}

const openHistory = () => {
  history.value.showMain = true;
}

// 恢复任务
const change_task = (status = '') => {
  ElMessageBox.confirm(status == 'stop' ? '确定暂停所有任务吗?' : '确定恢复所有任务吗？', '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning',
    beforeClose: (action, instance, done) => {
      if (action === 'confirm') {
        instance.confirmButtonLoading = true
        instance.confirmButtonText = '处理中...'
        api.updateTask(status).then(res => {
          console.log(res)
          if (res.code == 200) {
            ElMessage({
              type: 'success',
              message: (status == 'stop' ? '暂停' : '恢复') + '任务成功'
            })
            task_status.value = res.data;
            localStorage.setItem('task_status', res.data)
            setTimeout(()=>{
              router.go(0)
            },1000)
          } else {
            ElMessage({
              type: 'error',
              message: res.msg
            })
          }
        }).finally(() => {
          setTimeout(() => {
            done()
            instance.confirmButtonLoading = false
          }, 500)
        })
      } else {
        done()
      }
    }
  }).then(() => {

  }).catch(() => {

  })
}
</script>
